/**
 * Server-URL für Socket.IO & REST.
 *
 * Im Dev-Modus laufen Vite (5173) und der Game-Server (3001) auf
 * unterschiedlichen Ports. Damit der Zugriff aus dem LAN (z. B. vom Handy
 * über die Laptop-IP) automatisch funktioniert, nutzen wir denselben
 * Hostnamen wie die geladene Seite und hängen Port 3001 dran.
 *
 * In Production setzt man stattdessen `VITE_SERVER_URL` (z. B.
 * `https://api.samyziehtdichab.de`) – ohne Port, weil der Reverse-Proxy
 * des Hosters auf 443/HTTPS hört.
 */
function defaultServerUrl(): string {
  if (typeof window === "undefined") return "http://localhost:3001";
  const { protocol, hostname } = window.location;
  // Production-Build ohne explizite Server-URL: gleicher Host, Standard-Port.
  // (Ergibt z. B. `https://samyziehtdichab.de` – Server muss dann hinter
  //  einem Reverse-Proxy auf demselben Host laufen.)
  if (import.meta.env.PROD) {
    return `${protocol}//${hostname}`;
  }
  return `${protocol}//${hostname}:3001`;
}

export const SERVER_URL: string = import.meta.env.VITE_SERVER_URL ?? defaultServerUrl();
